import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";


export class setValues extends Component implements IActionBase {

    actionCode = "setValues";
    actionName = "setValues";



    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {
        if (!!prmActionParameters?.arrValuesToSet && prmActionParameters.arrValuesToSet?.length > 0) {

            let arrCurrValuesToSet = prmActionParameters.arrValuesToSet;

            for (let ind01 = 0; ind01 < arrCurrValuesToSet.length; ind01++) {
                let currValueToSet = arrCurrValuesToSet[ind01];

                let targetDataBind = "";
                let sourceValue = null;

                // Source
                if (!!currValueToSet.Source) {
                    if (!!currValueToSet.Source.ElementType
                        && currValueToSet.Source.ElementType == 'Element') {
                        if (currValueToSet.Source.ElementIdentifier.length > 0) {
                            let elementObj = dataUtils.getElementByClientID(currValueToSet.Source.ElementIdentifier);

                            if (elementObj.DataBindStr.length > 0) {
                                sourceValue = utils_ui.getDataItem(elementObj.DataBindStr);
                            }
                        }


                    } else if (!!currValueToSet.Source.ElementType
                        && currValueToSet.Source.ElementType == 'DataBind') {
                        if (currValueToSet.Source.DataBindStr.length > 0) {
                            sourceValue = utils_ui.getDataItem(currValueToSet.Source.DataBindStr);
                        }


                    } else if (!!currValueToSet.Source.ElementType
                        && currValueToSet.Source.ElementType == 'Constant') {
                        let currValue = utils_ui.getRelatedParamsForValue(currValueToSet.Source.ConstantValue);
                        sourceValue = dataUtils.convertValueToType(currValue, currValueToSet.Source.ElementDataType);

                    } else if (!!currValueToSet.Source.ElementType
                        && currValueToSet.Source.ElementType == 'UrlParameter') {
                        //Comment : use it here
                        const urlParams = new URLSearchParams(window.location.search);
                        // let currUrlParam = queryParams.get(currFilterObj.ConstValue); //urlParamsObj; //this.locationObj.search();



                        if (!!urlParams) {

                            let currValue = urlParams.get(currValueToSet.Source.UrlParameter);

                            //Comment: When we same url parameter multiple times
                            if (Array.isArray(currValue) && currValue.length > 0) {

                                currValue = currValue[0];
                            }

                            if (!!currValue) {

                                sourceValue = dataUtils.convertValueToType(currValue, currValueToSet.Source.ElementDataType);
                            }
                        }
                    }
                }

                // Target
                if (!!currValueToSet.Target) {
                    if (!!currValueToSet.Target.ElementType
                        && currValueToSet.Target.ElementType == 'Element') {

                        if (currValueToSet.Target.ElementIdentifier.length > 0) {

                            let elementObj = dataUtils.getElementByClientID(currValueToSet.Target.ElementIdentifier);

                            if (!!elementObj && elementObj?.DataBindStr?.length > 0) {
                                utils_ui.setDataItem(elementObj.DataBindStr, sourceValue,true);
                            }
                        }


                    } else if (!!currValueToSet.Target.ElementType
                        && currValueToSet.Target.ElementType == 'DataBind') {
                        if (currValueToSet.Target.DataBindStr.length > 0) {
                            utils_ui.setDataItem(currValueToSet.Target.DataBindStr, sourceValue,true);
                        }


                    }
                }


            }

        }

    }


}